import { LIST_TYPE, PROJECT_STATUS } from 'constants/constants';
import { MODAL_NAME } from 'constants/modal';
import usePage from 'hooks/usePage';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/reducers/modal';
import Page from 'views/common/Page';
import SmartTable from 'views/common/table/SmartTable';

const getDate = (date) => {
  if (!date) return;
  return moment(new Date(date)).format('hh:mm:ss DD/MM/yyyy');
};

const config = {
  mainKey: 'id',
  headerHeight: 50,
  rowHeight: 60,
  tableStyle: {
    minWidth: 700,
    maxHeight: 600,
  },
  columns: [
    {
      columnKey: 'No',
      title: 'No.',
      className: 'cell-y-center',
      render: (v, rowData) => {
        const { index } = rowData;
        return <span style={{ fontWeight: 400, paddingLeft: 5 }}>{index}</span>;
      },
      width: '2rem',
    },
    {
      columnKey: 'createdBy',
      title: 'Executor',
      width: '10%',

      className: 'cell-y-center',
    },
    {
      columnKey: 'type',
      title: 'Action',
      width: '25%',

      className: 'cell-y-center',
      render: (v) => {
        let text;
        switch (v) {
          case PROJECT_STATUS.CREATING:
            text = 'Update';
            break;
          case PROJECT_STATUS.WAITING_APPROVE:
            text = 'Submit for review';
            break;
          case PROJECT_STATUS.REJECT:
            text = 'Reject';
            break;
          case PROJECT_STATUS.APPROVED:
            text = 'Approve';
            break;
          case 'PAUSE':
            text = 'Pause';
            break;
          case 'RESUME':
            text = 'Resume';
            break;
          default:
            break;
        }

        return <span>{text}</span>;
      },
    },
    {
      columnKey: 'reason',
      title: 'Reason',
      width: '40%',

      className: 'cell-y-center',
      render: (v) => { 
        return (
          <span className="text" title={v}>
            {v}
          </span>
        );
      },
    },
    {
      columnKey: 'createdDate',
      title: 'Action date',
      width: '20%',
      className: 'cell-y-center',
      render: (v) => <span>{getDate(v)}</span>,
    },
    {
      columnKey: 'oldObject',
      title: 'Version Code',
      className: 'cell-y-center',
      render: (v, rowData, props) => {
        const { openPopupView, versionCurrent } = props;
        const { versionName } = JSON.parse(v || '{}');
        return (
          v &&
          (versionCurrent === versionName ? (
            <span className="cell-link-to">Current V.{versionName}</span>
          ) : (
            <span
              onClick={() => openPopupView(v)}
              style={{ cursor: 'pointer' }}
              className="cell-link-to"
            >
              View V.{versionName}
            </span>
          ))
        );
      },
    },
  ],
};

const History = ({ projectId, isPageApprove, versionCurrent }) => {
  const { status, data, meta, onChangePage, currentPage } = usePage({
    name: LIST_TYPE.HISTORY,
    pageSize: 5,
    defaultParams: {
      objectId: projectId,
      type: isPageApprove
        ? [
            PROJECT_STATUS.APPROVED,
            PROJECT_STATUS.REJECT,
            PROJECT_STATUS.WAITING_APPROVE,
            'PAUSE',
            'RESUME',
          ]
        : null,
    },
  });
  const dispatch = useDispatch();

  const openPopupView = (data) => {
    dispatch(
      openModal({
        name: MODAL_NAME.HISTORY_CODE,
        data,
      })
    );
  };

  return (
    <Page
      pageClass="history-custom"
      currentPage={currentPage}
      onChangePage={onChangePage}
      status={status}
      data={data}
      pageSize={5}
      renderList={() => (
        <SmartTable
          openPopupView={openPopupView}
          config={config}
          dataSource={data}
          versionCurrent={versionCurrent}
        />
      )}
      meta={meta}
    />
  );
};

export default History;
